import { rd } from '@passionware/monads';
import { FeatureService } from 'v5/services/front/FeatureService/FeatureService';
import { AppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService';

export function useManageEnterpriseFeature(
  featureService: FeatureService,
  appScopeService: AppScopeService
): boolean {
  return rd.getOrElse(
    featureService.useFeature(
      appScopeService.useOrganizationScopeIdentity(),
      'manage-enterprise'
    ),
    false
  );
}
